// Copyright (c) Proto Labs, Inc. All Rights Reserved.
import { ProfileProxy } from './ProfileProxy';
export class UserProxy {
    constructor(user) {
        this.user = user;
        this.userProfile = new ProfileProxy(user.profile);
    }
    get access_token() {
        return this.user.access_token;
    }
    get refresh_token() {
        return this.user.refresh_token;
    }
    get expires_in() {
        return this.user.expires_in;
    }
    get session_state() {
        return this.user.session_state;
    }
    get profile() {
        return this.userProfile;
    }
}
//# sourceMappingURL=UserProxy.js.map